module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213410.84fe4244.jpg";